<template>
  <div class="progress">
    <div class="progress-bar" role="progressbar" :style="{ width: width + '%' }" :aria-valuenow="value" aria-valuemin="0" :aria-valuemax="max"></div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number
      },
      max: {
        type: Number,
        default: 1
      }
    },
    computed:{
      width() {
        return this.value / this.max * 100;
      }
    }
  }
</script>